export default "__VITE_ASSET__Dw5XFN7s__"